// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import MessageCustomTimestamp from './messageTimestamp';
import CustomAvatar from './messageAvatar';

/**
 * @type{React.FC<import('types').MessageDeletedProps>}
 */
const MessageCustomDeleted = (props) => {
  const { message, formatDate  } = props;
  return (
      <div
        key={message.id}
        data-testid="message-team"
        className={`str-chat__message-team str-chat__message-team--top str-chat__message-team--${
          message?.type
        } str-chat__message-team--${
          message?.status
        }`}
      >
        <div className="str-chat__message-team-meta">
          <CustomAvatar
            image={message?.user?.image}
            name={message?.user?.name || message?.user?.id}
            size={40}
          />
          <MessageCustomTimestamp
            message={message}
            tDateTimeParser={props.tDateTimeParser}
            formatDate={formatDate}
          />
        </div>
        <div className="str-chat__message-team-group">
          <div
            data-testid="message-team-author"
            className="str-chat__message-team-author"
          >
            <strong>{message.user?.name || message.user?.id}</strong>
          </div>
          <div
            data-testid="message-team-content"
            className={`str-chat__message-team-content str-chat__message-team-content--top str-chat__message-team-content--${
              message?.text === '' ? 'image' : 'text'
            }`}
          >
            <div className="str-chat__message--deleted-inner">
              This message was deleted...
            </div>
          </div>
        </div>
      </div>
  );
};

MessageCustomDeleted.propTypes = {
  /** The [message object](https://getstream.io/chat/docs/#message_format) */
  // @ts-ignore
  // Ignoring this for now as Typescript definitions on 'strem-chat' are wrong.
  message: PropTypes.object,
  /** @deprecated This is no longer needed. The component should now rely on the user role custom hook */
  isMyMessage: PropTypes.func,
};

export default MessageCustomDeleted;